// Colors reference tokens defined in tailwind.config.js (theme.extend.colors.palette.*)
const STATUS_CONFIG = {
  pending: {
    label: "Pending",
    bg: "bg-palette-amber-soft",
    text: "text-palette-amber-text",
    dot: "bg-palette-amber-badge",
  },
  paid: {
    label: "Paid",
    bg: "bg-palette-emerald-soft",
    text: "text-palette-emerald-text",
    dot: "bg-palette-emerald-badge",
  },
  overdue: {
    label: "Overdue",
    bg: "bg-palette-rose-soft",
    text: "text-palette-rose-text",
    dot: "bg-palette-rose-badge",
  },
  scheduled: {
    label: "Scheduled",
    bg: "bg-palette-sky-soft",
    text: "text-palette-sky-text",
    dot: "bg-palette-sky-badge",
  },
  active: {
    label: "Active",
    bg: "bg-palette-emerald-soft",
    text: "text-palette-emerald-text",
    dot: "bg-palette-emerald-badge",
  },
  paused: {
    label: "Paused",
    bg: "bg-palette-amber-soft",
    text: "text-palette-amber-text",
    dot: "bg-palette-amber-badge",
  },
  cancelled: {
    label: "Cancelled",
    bg: "bg-palette-gray-subtle",
    text: "text-palette-gray-secondary",
    dot: "bg-palette-gray-placeholder",
  },
};

export default function PaymentStatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG.scheduled;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${cfg.bg} ${cfg.text}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full shrink-0 ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
}
